

export const PERMISOS = {
    // Consultar turnos con filtros
    M_TURNOS: "|menu|turnos|",
    P_CONSULTAR_TURNOS_FILTRO: "|turnos|consultaTurnos|acceso|",
    M_CONSULTAR_TURNOS_FILTRO: "|menu|turnos|consultaTurnos|",
    P_CONSULTAR_TURNOS_DESCARGAR_COMPROBANTE: "|turnos|consultaTurnos|descargarComprobante|",
    P_CONSULTAR_TURNOS_MARCAR_ASISTIDO: "|turnos|consultaTurnos|marcarAsistencia|",
    P_CONSULTAR_TURNOS_MARCAR_PENDIENTE: "|turnos|consultaTurnos|desmarcarAsistencia|",
    P_CONSULTAR_TURNOS_CANCELAR_TURNO: "|turnos|consultaTurnos|cancelarTurno|",
    P_CONSULTAR_TURNOS_RESERVA: "|turnos|consultaTurnos|reserva|",
    
    /////
    M_PROGRAMACION: "|menu|programacion|",
    // Administrar Bandas Horarias
    P_ADMINISTRAR_BANDAS_HORARIAS: "|programacion|adminBandaHoraria|acceso|",
    M_ADMINISTRAR_BANDAS_HORARIAS: "|menu|programacion|adminBandaHoraria|",
    // Administrar Proteccionistas
    P_ADMINISTRAR_PROTECCIONISTAS: "|admin|proteccionistas|acceso|",
    M_ADMINISTRAR_PROTECCIONISTAS: "|menu|admin|proteccionistas|",
    // Consulta de Programacion de Turnos
    P_CONSULTA_PROGRAMACION_TURNOS: "|programacion|consultaProgramacion|acceso|",
    M_CONSULTA_PROGRAMACION_TURNOS: "|menu|programacion|adminProgramacion|",
    /////
    M_ADMINISTRACION: "|menu|admin|", 
    // Feriados
    P_ADMINISTRAR_FERIADOS: "|admin|adminFeriados|acceso|",
    M_ADMINISTRAR_FERIADOS: "|menu|admin|feriados|",
    // Parametros generales
    P_ADMINISTRAR_PARAMETROS_SISTEMA: "|admin|parametros|acceso|",
    M_ADMINISTRAR_PARAMETROS_SISTEMA: "|menu|admin|parametros|",
    /////
    M_SEGURIDAD: "|menu|seguridad|",
    // Seguridad Usuarios
    P_ADMINISTRAR_USUARIOS: "|seguridad|usuarios|acceso|",
    M_ADMINISTRAR_USUARIOS: "|menu|seguridad|usuarios|",
    // Seguridad Rol
    P_ADMINISTRAR_ROL: "|seguridad|rol|acceso|",
    M_ADMINISTRAR_ROL: "|menu|seguridad|roles|",
    // Seguridad Grupos
    P_ADMINISTRAR_GRUPOS: "|seguridad|grupo|acceso|",
    M_ADMINISTRAR_GRUPOS: "|menu|seguridad|grupos|",
    // Seguridad Permisos
    P_ADMINISTRAR_PERMISOS: "|seguridad|permiso|acceso|",
    M_ADMINISTRAR_PERMISOS: "|menu|seguridad|permisos|",
    /////
    M_CUENTA: "|menu|cuenta|",
    // Modificar Datos Cuenta
    P_MODIFICAR_DATOS_CUENTA: "|cuenta|modificaciondatos|acceso|",
    M_MODIFICAR_DATOS_CUENTA: "|menu|cuenta|modificaciondatos|",
    // Modificar password
    P_MODIFICAR_PASSWORD_CUENTA: "|cuenta|modificacionclave|acceso|",
    M_MODIFICAR_PASSWORD_CUENTA: "|menu|cuenta|modificacionclave|",
    // Dashboard
    P_DASHBOARD: "|admin|dashboard|acceso|",
    M_DASHBOARD: "|menu|dashboard|",
    P_DASHBOARD_DESCARGAR_COMPROBANTE: "|admin|dashboard|descargarComprobante|",
    P_DASHBOARD_MARCAR_ASISTIDO: "|admin|dashboard|marcarAsistencia|",
    P_DASHBOARD_MARCAR_PENDIENTE: "|admin|dashboard|desmarcarAsistencia|",
    P_DASHBOARD_CANCELAR_TURNO: "|admin|dashboard|cancelarTurno|",

    P_TURNOS_RESERVAR: "|turnos|reservaTurnos|reservar|",

}